// Conteúdo extraído dos sites oficiais da Dra. Nivalda (Doctoralia + nivaldapdejesus.com.br)

export const PROFILE = {
  name: "Profª Drª Nivalda P. de Jesus",
  short_name: "Dra. Nivalda",
  crp: "CRP 06/41032-6",
  title: "Neuropsicóloga • Psicóloga Clínica • Sexóloga",
  city: "Santos / SP",
  experience_years: 26,
  phone_landline: "(13) 3286-1757",
  phone_landline_tel: "+551332861757",
  whatsapp_display: "(13) 99775-7710",
  whatsapp_raw: "5513997757710",
  email: "nivaldapj@hotmail.com",
  address_line1: "Avenida Ana Costa, 482 — Conjunto 907",
  address_line2: "Gonzaga • Santos / SP • 11060-002",
  instagram: "https://www.instagram.com/dranivalda/",
  instagram_handle: "@dranivalda",
  facebook: "https://www.facebook.com/dranivalda.dejesus.3",
  doctoralia: "https://www.doctoralia.com.br/nivalda-purificacao-de-jesus/psicologo-sexologo/santos",
  doctoralia_reviews: "https://www.doctoralia.com.br/nivalda-purificacao-de-jesus/psicologo-sexologo/santos#profile-reviews",
  doctoralia_booking: "https://www.doctoralia.com.br/nivalda-purificacao-de-jesus/psicologo-sexologo/santos#highlight-calendar",
  languages: ["Português", "Inglês", "Espanhol", "Francês"],
  consultation_format: ["Presencial", "Teleconsulta"],
  patients: ["Adultos", "Crianças", "Adolescentes", "Casais", "Famílias"],
  map_embed:
    "https://www.google.com/maps?q=Avenida%20Ana%20Costa%2C%20482%20-%20Gonzaga%2C%20Santos%2FSP&output=embed",
};

export const EDUCATION = [
  { title: "Doutorado em Psicologia Clínica", institution: "Universidade de São Paulo — USP" },
  { title: "Mestrado em Psicologia Preventiva", institution: "Universidade Metodista de São Paulo — UMESP (Bolsista CNPq)" },
  { title: "Especialista em Neuropsicologia", institution: "HCFMUSP — Hospital das Clínicas da Faculdade de Medicina da USP" },
  { title: "Especialista em Sexologia", institution: "ProSex — FMUSP" },
  { title: "Especialista em Psicanálise", institution: "Universidade de São Paulo — USP" },
  { title: "Especialista em Transtorno Alimentar e Obesidade", institution: "CEPSIC" },
  { title: "Especialista em Violência Sexual Doméstica", institution: "LACRI / USP" },
  { title: "Especialização em Terapia Cognitivo-Comportamental", institution: "Screener" },
  { title: "Graduação em Psicologia", institution: "Universidade Católica de Santos" },
];

export const AREAS = [
  {
    id: "neuropsicologia",
    title: "Neuropsicologia",
    icon: "Brain",
    description:
      "Avaliação e acompanhamento das funções cognitivas: atenção, memória, raciocínio, linguagem e funções executivas.",
    image:
      "https://images.unsplash.com/photo-1530026405186-ed1f139313f8?auto=format&fit=crop&w=640&q=80",
  },
  {
    id: "individual",
    title: "Terapia Individual",
    icon: "User",
    description:
      "Espaço de escuta qualificada para adultos, adolescentes e idosos — acolhimento ético para processos de autoconhecimento.",
    image:
      "https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=640&q=80",
  },
  {
    id: "casal",
    title: "Terapia de Casal",
    icon: "Heart",
    description:
      "Reconstrução do diálogo, da intimidade e da confiança. Ajuda para crises conjugais, infidelidade e reorganização do vínculo.",
    image:
      "https://images.unsplash.com/photo-1494774157365-9e04c6720e47?auto=format&fit=crop&w=640&q=80",
  },
  {
    id: "familiar",
    title: "Terapia Familiar",
    icon: "Users",
    description:
      "Cuidado sistêmico para as relações familiares: conflitos, limites, parentalidade e comunicação entre gerações.",
    image:
      "https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=640&q=80",
  },
  {
    id: "sexual",
    title: "Terapia Sexual",
    icon: "Sparkles",
    description:
      "Saúde íntima da mulher e do homem, disfunções sexuais, parafilias, educação sexual e ressignificação da sexualidade.",
    image:
      "https://images.unsplash.com/photo-1518199266791-5375a83190b7?auto=format&fit=crop&w=640&q=80",
  },
  {
    id: "vocacional",
    title: "Orientação Vocacional",
    icon: "Compass",
    description:
      "Apoio para decisões de carreira, transição profissional e autoconhecimento vocacional em adolescentes e adultos.",
    image:
      "https://images.unsplash.com/photo-1508847154043-be5407fcaa5a?auto=format&fit=crop&w=640&q=80",
  },
  {
    id: "alimentar",
    title: "Transtorno Alimentar",
    icon: "Apple",
    description:
      "Tratamento de compulsão, obesidade, anorexia, bulimia e avaliação psicológica para cirurgia bariátrica.",
    image:
      "https://images.unsplash.com/photo-1498837167922-ddd27525d352?auto=format&fit=crop&w=640&q=80",
  },
  {
    id: "tcc",
    title: "Terapia Cognitivo-Comportamental",
    icon: "Lightbulb",
    description:
      "Abordagem estruturada e baseada em evidências para ansiedade, depressão, pânico, fobias e reestruturação de padrões.",
    image:
      "https://images.unsplash.com/photo-1499750310107-5fef28a66643?auto=format&fit=crop&w=640&q=80",
  },
];

export const CONDITIONS = [
  "Depressão",
  "Transtornos de ansiedade",
  "Síndrome do pânico",
  "Ataques de pânico",
  "Transtorno depressivo",
  "Insônia",
  "Angústia",
  "Luto",
  "Dificuldades no relacionamento",
  "Conflitos de casal",
  "Dependência química",
  "Transtornos alimentares",
  "Compulsão alimentar",
  "Disfunções sexuais",
  "Perda e aumento de libido",
  "Violência doméstica",
  "Abuso sexual",
  "Bullying",
  "TDAH",
  "Saúde mental no trabalho",
];

export const SERVICES_PRICES = [
  { name: "Consulta Psicológica", price: "A partir de R$ 390" },
  { name: "Consulta de Sexologia", price: "R$ 390" },
  { name: "Primeira Consulta", price: "R$ 390" },
  { name: "Terapia Cognitivo-Comportamental", price: "A partir de R$ 390" },
  { name: "Terapia de Casal", price: "A partir de R$ 600" },
  { name: "Terapia Familiar", price: "A partir de R$ 600" },
  { name: "Avaliação Neuropsicológica completa", price: "R$ 2.100" },
  { name: "Teleconsulta", price: "R$ 390" },
];

export const FAQ = [
  {
    q: "Quais são as especialidades da Dra. Nivalda?",
    a: "Psicóloga clínica, Neuropsicóloga e Sexóloga, com especializações em Terapia Cognitivo-Comportamental, Psicanálise, Transtorno Alimentar e Violência Sexual Doméstica. Mais de 26 anos de experiência clínica.",
  },
  {
    q: "Onde fica o consultório?",
    a: "Avenida Ana Costa, 482 — Conjunto 907, Gonzaga, Santos/SP (11060-002). Atendimento também disponível por teleconsulta.",
  },
  {
    q: "É possível fazer atendimento online?",
    a: "Sim. A Dra. Nivalda atende por teleconsulta com o mesmo compromisso ético e técnico do atendimento presencial — basta agendar pelo formulário ou WhatsApp.",
  },
  {
    q: "Quais métodos de pagamento são aceitos?",
    a: "Dinheiro, Transferência Bancária e PIX. O atendimento é apenas particular — não são aceitos convênios.",
  },
  {
    q: "Em quais idiomas são oferecidas as consultas?",
    a: "Português, Inglês, Espanhol e Francês.",
  },
  {
    q: "Como é feita uma Avaliação Neuropsicológica?",
    a: "A Avaliação Neuropsicológica é composta por testes padronizados para a população brasileira que aferem atenção, concentração, tipos de memória, praxias, QI e humor. A primeira sessão costuma ser feita com um responsável que conheça bem o paciente. O resultado auxilia o médico no diagnóstico preciso.",
  },
  {
    q: "Atende imigrantes ou pessoas que não falam português?",
    a: "Sim. A Dra. Nivalda atende em Português, Inglês, Espanhol e Francês — uma das poucas profissionais em Santos com fluência clínica nesses quatro idiomas. Imigrantes, expatriados e brasileiros que vivem fora do país podem ser atendidos por teleconsulta de qualquer lugar do mundo.",
  },
  {
    q: "Atende crianças e adolescentes?",
    a: "Sim. O consultório atende crianças, adolescentes, adultos e idosos, incluindo terapia familiar e orientação aos pais.",
  },
];
